import React, { useEffect, useState, useMemo } from "react";
import { Pagination } from "../../../components/Pagination";
import { ModalBase } from "../../../components/Modals/ModalBase";
import { useDispatch, useSelector } from "react-redux";
import {
    gp_lp_OpenModalSucursales,
    gp_lp_SetSucursalesSeleccionadas,
    gp_lp_SetProductoSeleccionado
} from "../../../actions/gestion-producto/lista-producto/listaProductos.actions";
import { State } from "../../../reducers";
import { bindActionCreators } from "redux";
import { actionsGPlistarProductos } from "../../../actions/action-creators";
import { convertStringToNit } from "../../../utils/strings.utils";

const ModalSignacionSucursalesProducto = () => {
    const sucursales = useSelector(
        (state: State) => state.gestionProducto.listarProductos.catalogos.sucursales
    );
    const seleccionado = useSelector(
        (state: State) => state.gestionProducto.listarProductos.productoSeleccionado
    );

    const [currentItems, setCurrentItems] = useState<Array<any>>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);

    const dispatch = useDispatch();
    const acciones = bindActionCreators(actionsGPlistarProductos, dispatch);

    const sucursalesActivas = useMemo(
        () => sucursales.filter(sucu => sucu.activo === "true" && sucu.eliminado !== "1"),
        [sucursales]
    );

    const asignadas = useMemo(
        () => sucursales.filter(s => s.Relacionada === true || s.Relacionada === "true").map(s => String(s.idsucursal)),
        [sucursales]
    );

    useEffect(() => {
        if (sucursales.length === 0) {
            acciones.gp_lp_getSucursales();
        }
    }, []);

    useEffect(() => {
        if (sucursalesActivas.length > 0) {
            setSelectedRows(asignadas);
            setSelectAll(asignadas.length === sucursalesActivas.length);
        }
    }, [seleccionado, sucursalesActivas, asignadas]);

    useEffect(() => {
        dispatch(gp_lp_SetSucursalesSeleccionadas(selectedRows));
    }, [selectedRows, dispatch]);

    const handleCheckboxChange = (event: any, rowId: string) => {
        if (event.target.checked) {
            setSelectedRows([...selectedRows, rowId]);
        } else {
            setSelectedRows(selectedRows.filter((id) => id !== rowId));
        }
    };

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
        if (newSelectAll) {
            setSelectedRows(sucursalesActivas.map(sucursal => String(sucursal.idsucursal)));
        } else {
            setSelectedRows([]);
        }
    };

    const closeModal = () => {
        dispatch(gp_lp_OpenModalSucursales(false));
        dispatch(gp_lp_SetProductoSeleccionado(null));
    };

    const asignarDesasignarSucursal = () => {
        if (seleccionado?.flagAsignacion) acciones.gp_lp_AsignarDesasignarSucurales();
    };

    return (
        <ModalBase
            Styles={{
                minWidth: "25%",
                maxWidth: "900px",
                backgroundColor: "#f1f1f1",
                padding: "2%"
            }}
        >
            <div>
                <h4 className="h4-titles">Asignar Sucursales al Producto</h4>
                <div className="tab-plane mt-16">
                    <table className="ta-cu-table-main-responsive ta-cu-responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>
                                    <label className="w-checkbox" style={{ marginLeft: "3%" }}>
                                        <input
                                            autoComplete="off"
                                            type="checkbox"
                                            checked={selectedRows.length === sucursalesActivas.length}
                                            onChange={handleSelectAll}
                                        />
                                        <div className="checkbox__checkmark"></div>
                                        <div className="checkbox__body" style={{ fontWeight: "400" }}>
                                            No. Sucursal
                                        </div>
                                    </label>
                                </td>
                                <td>Nombre</td>
                                <td>Dirección</td>
                                <td>NIT</td>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length === 0 && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: "center", padding: "20px 0px" }}>
                                        No hay sucursales activas para asignar al producto
                                    </td>
                                </tr>
                            )}
                            {currentItems.map((element, index) => (
                                <tr key={index}>
                                    <td data-label="No. Sucursal" onClick={(e) => e.stopPropagation()}>
                                        <label className="w-checkbox" style={{ marginLeft: "3%" }}>
                                            <input
                                                autoComplete="off"
                                                type="checkbox"
                                                checked={selectedRows.includes(String(element?.idsucursal))}
                                                onChange={(e) => handleCheckboxChange(e, String(element?.idsucursal))}
                                            />
                                            <div className="checkbox__checkmark"></div>
                                            <div className="checkbox__body fw-400">{index + 1}</div>
                                        </label>
                                    </td>
                                    <td data-label="Nombre">{element.nombre}</td>
                                    <td data-label="Dirección">{element.direccion}</td>
                                    <td data-label="NIT">{convertStringToNit(String(element.nit))}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Pagination
                        data={sucursalesActivas}
                        state={(items: Array<any>) => setCurrentItems(items)}
                        items={15}
                    />
                </div>
            </div>
            <br />
            <div className="w-layout-hflex button-actions">
                <button type="button" className="m button transparent w-inline-block" onClick={closeModal}>
                    Cancelar
                </button>
                <button
                    type="button"
                    disabled={sucursalesActivas.length === 0}
                    className="m button w-inline-block"
                    onClick={asignarDesasignarSucursal}
                >
                    Confirmar
                </button>
            </div>
        </ModalBase>
    );
};

export default ModalSignacionSucursalesProducto;
